export default __webpack_public_path__ + "static/media/email.fd1e52c3.png";